import { IFormattedStop, IShipment, IShipmentInfo } from 'types'
import callApi, { ENDPOINTS } from 'utils/api/callApi'

/**
 * Update shipment status: 'Remove Hold' / 'Hold'
 */
export const updateShipmentStatus = ({
  id,
  statusChangeKey,
}: {
  id: string
  statusChangeKey: string
}): Promise<IShipment> =>
  callApi({
    endpoint: ENDPOINTS.shipments,
    method: 'PUT',
    group: 'update_status',
    id,
    dataKey: 'shipment',
    body: {
      statusChangeKey,
    },
  })

/**
 * Resend 214's
 */
export const resend214 = (id: string): Promise<{}> =>
  callApi({
    endpoint: ENDPOINTS.shipments,
    method: 'POST',
    group: 'resend_214',
    id,
    dataKey: 'shipment',
  })

interface IQuickRequestResponse {
  appointmentRequest: string
  appointmentRequestDate: string
  appointmentRequestLogUuid: string
  appointmentRequestTime: string
  autoConfirmToken: string
  createdAt: string
  createdById: number
  deprecatedAt: string
  id: number
  isIdeal: false
  lastRequestedAt: string
  requestedCount: number
  shipmentStopId: number
  source: 'quick_request'
  updatedAt: string
}

interface IQuickRequestParams {
  id: string
  stopId: number
}

/**
 * Quick Request
 */
export const quickRequest = ({ id, stopId }: IQuickRequestParams): Promise<IQuickRequestResponse> =>
  callApi({
    endpoint: ENDPOINTS.shipments,
    method: 'POST',
    id,
    group: `shipment_stops/${stopId}/quick_request`,
  })

enum SHIPMENT_PARAMS_INCLUDES {
  /* eslint-disable camelcase */
  driver_tracking_information = 0,
  shipper_insurance_requirement,
  auto_appts,
  project44_metadata,
  backhaul_eligible_lanes,
  reschedule_requests,
  /* eslint-enable camelcase */
}

type ShipmentIncludes = keyof typeof SHIPMENT_PARAMS_INCLUDES

export interface IGetShipmentDetailRequest {
  id: string
  includes?: ShipmentIncludes[]
}

export interface IGetShipmentDetailResponse {
  shipment: IShipment
}

/**
 * Get shipment details by id
 * @method GET
 */
export const getShipmentDetail = ({
  id,
  includes,
}: IGetShipmentDetailRequest): Promise<IShipment> =>
  callApi({
    endpoint: ENDPOINTS.shipments,
    method: 'GET',
    dataKey: 'shipment',
    id,
    ...(includes
      ? {
          params: {
            includes,
          },
        }
      : {}),
  })

export interface IEditShipmentPayload {
  stops: IFormattedStop[]
  info: Partial<IShipmentInfo>
}
export interface IEditShipmentDetailRequest extends IGetShipmentDetailRequest {
  shipment: IEditShipmentPayload
}

/**
 * Edit shipment details
 * @method PUT
 */
export const editShipmentDetail = ({
  id,
  includes,
  shipment,
}: IEditShipmentDetailRequest): Promise<IGetShipmentDetailResponse> =>
  callApi({
    endpoint: ENDPOINTS.shipments,
    method: 'PUT',
    dataKey: 'shipment',
    id,
    ...(includes
      ? {
          params: {
            includes,
          },
        }
      : {}),
    body: { shipment },
  })
